import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { DialogsContext } from './DialogsContext';
/**
 * DialogRenderer is used to render actual Dialog inside AK ModalTransition.
 */
export default function DialogRenderer(props) {
  const {
    DialogComponent,
    isOpen,
    onClose,
    dialogProps
  } = props;
  const {
    closeDialog
  } = useContext(DialogsContext);
  if (!DialogComponent) {
    return null;
  }
  const handleCloseDialog = () => {
    closeDialog();
    if (onClose) {
      onClose();
    }
    if (dialogProps !== null && dialogProps !== void 0 && dialogProps.onClose) {
      dialogProps.onClose();
    }
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, isOpen && /*#__PURE__*/React.createElement(DialogComponent, _extends({}, dialogProps, {
    onClose: handleCloseDialog
  })));
}